import { Component, OnInit } from '@angular/core';
import {FirstContactService} from "./first-contact.service";
import {CompanyDetailsDtoModel, SignupFirstContactDto, SignupFirstContactMeta} from "@well/domain";
import {Router} from "@angular/router";
import {switchMap} from "rxjs";
import {JsonApiResource} from "@irian-ro/abstract-resource";

@Component({
  selector: 'signup-first-contact',
  templateUrl: './first-contact.component.html',
  styleUrls: ['./first-contact.component.scss'],
  providers: [FirstContactService]
})
export class FirstContactComponent implements OnInit {

  iconClass = 'ui-icon-contact-mail';
  meta: SignupFirstContactMeta | undefined = undefined;
  firstContact: SignupFirstContactDto | undefined = undefined;
  currentCompanyDetails: CompanyDetailsDtoModel | undefined = undefined;

  constructor(private firstContactService: FirstContactService,
              private router: Router) {}

  ngOnInit(): void {
    this.firstContactService.getTemplate()
      .subscribe((template) => {
        this.meta = template.meta;
        this.firstContact = template.data;
    });

    this.firstContactService.getCurrentCompanyRegistration()
      .subscribe((companyDetailsResource:JsonApiResource<CompanyDetailsDtoModel, any>) => {
        this.currentCompanyDetails = companyDetailsResource.data;
      });
  }

  onFirstContactSave(event: SignupFirstContactDto){
    const companyName = this.currentCompanyDetails?.legalEntityDTO?.companyType;

    if(!companyName) {
      return;
    }

    this.firstContactService.saveFirstContact(event)
    .pipe(
      switchMap(() => {
        return this.firstContactService.assignInitialRoleToCurrentUser(companyName);
      }
    ))
    .subscribe(() => {
      this.router.navigate(['/auth/login']);
    });
  }

}
